"use strict";
// globalDataLogger is for dumping forensic data to rollbar when something bad happens
var clone = require('clone');
var log = require('bunsen/helpers/log');
var logger = module.exports = {
    reset : function () {
        logger._eventLog = [];
    },
    event : function (obj) {
        logger._eventLog = logger._eventLog || [];
        if ('object' === typeof obj) {
            obj = clone(obj);
        }
        logger._eventLog.push(obj);
    },
    stringify : function () {
        return window.JSON.stringify(logger._eventLog);
    },
    flush : function () {
        if (0 === logger._eventLog.length) {
            return;
        }
        log.remote.error(window.JSON.stringify(logger._eventLog));
        logger.reset();
    }
};



// WEBPACK FOOTER //
// ./~/bunsen/libraries/globalDataLogger.es.js